<template>
  <div id="app">
    <header class="header" v-if="currentUser"><app-header></app-header></header>
    <div class="main">
      <div class="container">
        <transition name="fade" mode="out-in">
          <router-view :key="$route.fullPath"></router-view>
        </transition>
      </div>
    </div>
    <footer class="app-footer bg-dark"><app-footer></app-footer></footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'app',

  computed: {
    ...mapGetters({ currentUser: 'currentUser' })
  },

  created () {
    this.checkCurrentLogin()
  },

  updated () {
    this.checkCurrentLogin()
  },

  methods: {
    logout: function () {
      delete localStorage.token
      this.$router.push({name: 'login'})
      this.$store.dispatch('logout')
    },

    checkCurrentLogin () {
      /* si el usuario no está logueado redirigimos al login */
      if (!this.currentUser && this.$route.path !== '/' && this.$route.path !== '/login') {
        this.$router.push('/?redirect=' + this.$route.path)
      }
      /* si el usuario está logueado excluimos la ruta de login */
      if (this.currentUser && this.$route.path === '/login') {
        this.$router.push('/home')
      }
    }
  },

  components: {
    'app-header': Header,
    'app-footer': Footer
  }
}
</script>

<style lang="scss">
</style>
